import React from 'react';
import PropTypes from 'prop-types';
import { StyledParagraph } from './styles';

/**
 * This is the body text used across the site. Default size is 20px but if it is contained in a card, default size is 18px.
 */
const Paragraph = ({ children, align, ...props }) => (
  <StyledParagraph align={align} {...props}>
    {children}
  </StyledParagraph>
);

Paragraph.propTypes = {
  align: PropTypes.oneOf(['left', 'right', 'center', 'inherit']),
};

Paragraph.defaultProps = {
  align: 'inherit',
};

export default Paragraph;
